<template>
	<ModalDialog
		:buttons="[[{name: 'cancel', caption: $t('cancel'), classes: 'btn-outline-secondary', clickFn: cancelClickedHandler, isDisabled: false}],
					[{name: 'ok', caption: $t('ok'), classes: 'btn-success', clickFn: okClickedHandler, isDisabled: !isModalOkEnabled}]]"
		@escKeyPressed="escKeyPressedHandler">
		<template v-slot:title>{{ $t(`modal_edit_user_note_comment_title`) }}</template>
		<template v-slot:body>
			<div class="row mb-2">
				<div class="col-12">
					<label class="col-form-label">{{ $t('insert_comment') }}</label>
					<TextareaAutosize v-model="commentText" :max-height="maxHeight" :min-height="minHeight" class="form-control w-100 p-1"></TextareaAutosize>
				</div>
			</div>
		</template>
		<template v-slot:errorMessage v-if="errorMessage">
				<span class="font-weight-semibold text-right p-3 text-danger ">{{errorMessage}}</span>
		</template>
	</ModalDialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import ModalDialog from './ModalDialog.vue';
import { CONSTANTS } from '../resources/constants.js';

export default {
	props: ['item', 'version'],

	components: {
		ModalDialog,
	},

	data() {
		return {
			commentDate: null,
			commentText: null,
			errorMessage: null,
		};
	},

	computed: {
		...mapState([
			'series',
		]),

		isModalOkEnabled() {
			return true;
		},

		maxHeight() {
			return CONSTANTS.textareaAutosize.maxHeight;
		},

		minHeight() {
			return CONSTANTS.textareaAutosize.minHeight;
		},
	},

	methods: {
		...mapMutations([
			'updateUserNotes',
			'updateUserNotesSeriesDocumentsLinkList',
			'updateUsageTrackerStorage',
		]),

		...mapActions([
			'getLocalIP',
			'saveUserNotesItem',
		]),

		cancelClickedHandler() {
			this.$emit('cancelClicked');
		},

		escKeyPressedHandler() {
			this.cancelClickedHandler();
		},

		okClickedHandler() {
			this.$emit('okClicked');
			this.updateUserNotes({ name: this.item.title, seriesId: this.version.seriesId, commentText: this.commentText });

			this.getLocalIP().then((localIp) => {
				this.updateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.editUserNoteComment, data: { documentName: this.item.title, seriesId: this.version.seriesId, versionId: this.version.id, comment: this.commentText }, localIp });
			});
			this.saveUserNotesItem().then(() => {
				// we have to update the documents of ALL VERSIONS OF ALL SERIES, because if the list is already loaded, this user's notes are not updated.
				this.series.forEach((s) => s.versions.forEach((v) => {
					if (v.documentationLinksList) {
						v.documentationLinksList.content.forEach((d) => {
							this.updateUserNotesSeriesDocumentsLinkList({ document: d, seriesId: s.id });
						});
					}
				}));
			}).catch(() => {
				this.errorMessage = this.$t('error_saving_data');
			});
		},
	},

	created() {
		this.commentText = this.item.comment ? this.item.comment.text : '';
		this.commentDate = this.item.comment ? this.$dayjs(this.item.comment.dateYMD).format('YYYY-MM-DD') : '';
	},
};
</script>
